import { useEffect } from "react";
import { Link, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { Button, Spin } from "antd";
import { LoadingOutlined, KeyOutlined } from "@ant-design/icons";
import { buildPasswordResetAppUrl } from "@/frontend/utils/appDeepLink";

/** Misma lógica que JoinPoolPage: esquema `worldcupadp://join` (host ya registrado en la app). */
export function PasswordResetOpenPage() {
  const { token: routeToken } = useParams<{ token?: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = routeToken || searchParams.get("token") || undefined;
  const appResetUrl = token ? buildPasswordResetAppUrl(token) : "";
  const webResetUrl = token
    ? `/reset-password?token=${encodeURIComponent(token)}`
    : "/forgot-password";

  useEffect(() => {
    if (!token) {
      navigate("/forgot-password", { replace: true });
      return;
    }

    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (!isMobile) {
      navigate(webResetUrl, { replace: true });
      return;
    }

    const timer = window.setTimeout(() => {
      window.location.href = appResetUrl;
    }, 350);

    return () => window.clearTimeout(timer);
  }, [token, appResetUrl, navigate, webResetUrl]);

  const handleOpenApp = () => {
    if (!token) return;
    window.location.href = appResetUrl;
  };

  if (!token) {
    return null;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-emerald-900 flex items-center justify-center p-4">
      <div className="bg-slate-800/50 backdrop-blur-xl rounded-2xl p-8 max-w-md w-full border border-slate-700/50 shadow-2xl text-center">
        <div className="w-16 h-16 bg-emerald-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <KeyOutlined className="text-emerald-400 text-2xl" />
        </div>
        <Spin
          indicator={<LoadingOutlined style={{ fontSize: 32, color: "#10b981" }} spin />}
          className="mb-4"
        />
        <h1 className="text-2xl font-bold text-white mb-3">Abrir en la app</h1>
        <p className="text-slate-400 mb-8">
          Toca el botón para restablecer tu contraseña en ADP Sports.
        </p>
        <div className="space-y-3">
          <Button
            type="primary"
            size="large"
            block
            onClick={handleOpenApp}
            className="h-12 bg-emerald-600 hover:bg-emerald-500 border-none font-semibold"
          >
            Abrir en la app
          </Button>
          <Button
            size="large"
            block
            onClick={() => navigate(webResetUrl)}
            className="h-12 bg-slate-700 hover:bg-slate-600 border-slate-600 text-white"
          >
            Continuar en el navegador
          </Button>
        </div>
        <Link
          to="/login"
          className="inline-block mt-8 text-slate-500 hover:text-emerald-400 text-sm font-medium"
        >
          Volver al inicio de sesión
        </Link>
      </div>
    </div>
  );
}
